import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CompanyFormComponent } from '../../components/company-form/company-form.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { CompanyRequest } from '../../company.model';
import { CompanyStore } from '../../company.store';
import {SHARED_IMPORTS} from "../../../../shared/modules/shared-imports.module";

@Component({
  selector: 'app-company-create-page',
  imports: [RouterLink, CompanyFormComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './company-create.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CompanyCreatePage {
  private readonly router = inject(Router);
  protected readonly companyStore = inject(CompanyStore);

  protected onSubmit(request: CompanyRequest): void {
    this.companyStore.createCompany(request, () => {
      void this.router.navigate(['/companies']);
    });
  }
}
